import React, { useState } from "react";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import AgendaTable from "./AgendaTable";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import CommonForm from "./CommonForm";

type Props = {};

const AgendaScreen = (props: Props) => {
  const [isModal, setIsModal] = useState(false);

  const handleEdit = () => {
    setIsModal(true);
  };

  const toggle = () => {
    setIsModal(!isModal);
  };
  const AddGgenda = () => {
    setIsModal(true);
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Agenda"
        buttons={[
          {
            label: "+Add Agenda",
            onClick: AddGgenda,
          },
          {
            label: "Excle",
            onClick: () => alert("Add Excle"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Add CSV"),
            color: "#43B9B2",
          },
        ]}
      />
      <AgendaTable />
      <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isModal}
        title="Add Agenda"
        content={<CommonForm 
          setIsModal={setIsModal}
          onPressForCancilModal={toggle}
        />}
      />
    </div>
  );
};

export default AgendaScreen;
